export const HOLD_BILLING_TESTID_PREFIX = 'hold-billing';

export const testIdSlug = (value?: string | number | null): string =>
  String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const holdTestId = (...parts: Array<string | number | null | undefined>): string =>
  [HOLD_BILLING_TESTID_PREFIX, ...parts.map(testIdSlug)].filter(Boolean).join('-');

export const holdRowTestId = (
  base: string,
  identity: string | number | null | undefined,
  suffix?: string
): string | undefined => (testIdSlug(identity) ? holdTestId(base, identity, suffix) : undefined);

/** A note is identified by its daily session note id, which is what the hold acts on. */
export const noteKey = (document?: {
  dailySessionNoteUuid?: string | null;
  uuid?: string | null;
}): string => document?.dailySessionNoteUuid ?? document?.uuid ?? '';
